<template>
  <div class="container mt-5">

    <div class="scroll-container">

      <h1 class="text-center mb-4">Confirm Your Details</h1>

      <!-- Display each piece of user information -->
      <div v-for="(value, label) in userInfo" :key="label" class="info-row">
        <h6 class="text-muted">{{ label }}</h6>
        <p>{{ value }}</p>
      </div>

      <!-- Error message -->
      <div v-if="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>

      <!-- Terms and Conditions Agreement -->
      <div class="form-check my-3">
        <input type="checkbox" id="termsAndConditions" class="form-check-input" v-model="termsAndConditionsAccepted" />
        <label for="termsAndConditions" class="form-check-label">
          I accept the <a href="#" @click.prevent="showModal">Terms and Conditions</a>
        </label>

      </div>

      <!-- Confirm button -->
      <button class="btn btn-primary w-100" :disabled="isLoading || !termsAndConditionsAccepted" @click="submitToApi">
        <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status"></span>
        <span v-else>Confirm And Submit</span>
      </button>
    </div>
    <!-- Terms and Conditions Modal -->
    <div v-if="showTermsModal" @click="closeModal" class="modal-overlay">
      <div @click.stop class="modal-content">
        <button class="close-btn" @click="closeModal">✓</button>
        <div v-html="termsHtml"></div>
      </div>
    </div>
  </div>




</template>

<script>
import terms from '@/assets/terms-and-conditions.md';
import { marked } from 'marked';
import { mapActions, mapState } from "vuex";

export default {
  props: ['form'],
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      termsAndConditionsAccepted: false,
      showTermsModal: false, // Modal visibility state
      termsHtml: marked(terms), // Parsed HTML
    };
  },
  computed: {
    // Dynamically generate the user information for display
    userInfo() {
      return {
        'First Name': this.form.firstName,
        'Last Name': this.form.lastName,
        Email: this.form.email,
        // Phone: this.form.phone,
        // Address: `${this.form.address1}, ${this.form.city}, ${this.form.state} ${this.form.zip}`,
        'Date of Birth': this.form.dateOfBirth,
      };
    },
  },
  methods: {
    ...mapActions(["login"]), // Map Vuex actions

    showModal() {
      this.showTermsModal = true;
    },
    closeModal() {
      this.showTermsModal = false;
    },
    async submitToApi() {
      this.isLoading = true;
      try {
        const customerDTO = {
          firstName: this.form.firstName,
          // middleName: this.form.middleName,
          lastName: this.form.lastName,
          email: this.form.email,
          country: "USA",
          // state: this.form.state,
          // city: this.form.city,
          // address1: this.form.address1,
          // address2: this.form.address2,
          // zip: this.form.zip,
          // phoneNumber: this.form.phone,
          dateOfBirth: this.form.dateOfBirth,
          password: this.form.password,
        };

        const customerSignupDTO = {
          customerDTO: customerDTO,
          stateLoginDTOS: [] // Assuming you have a list of StateLoginDTOs to include
        };

        const response = await fetch(this.$API_BASE_URL + '/api/customers', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(customerSignupDTO),
        });

        if (response.ok) {
          const responseData = await response.json();
          this.login(responseData.expiration);
          alert('Customer information submitted successfully!');
          this.$emit('showHome');
        } else {
          const errorData = await response.json();
          console.log('Error:', errorData);
          this.errorMessage = `Error: ${errorData.message}`;
        }
      } catch (error) {
        console.log('Error:', errorData);

        this.errorMessage = `Error: ${error.message}`;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  /* Ensure the modal stays fixed in the viewport */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Dark overlay background */
  display: flex;
  /* Flexbox for centering content */
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  z-index: 1000;
  /* Ensure it is above other elements */
}

.modal-content {
  background: white;
  /* Modal background */
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
  /* Limit the width of the modal */
  max-height: 80vh;
  /* Prevent the modal from overflowing vertically */
  overflow-y: auto;
  /* Allow scrolling if content overflows */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  /* Add a shadow for emphasis */
  position: relative;
  /* Allow child elements like the close button to be positioned relative to this */
}

.close-btn {
  position: sticky;
  /* Sticky positioning within the modal-content */
  margin-left: auto;
  /* Push it to the right edge */
  background: green;
  /* Green background for success look */
  border: none;
  /* Remove default button border */
  border-radius: 50%;
  /* Fully circular button */
  width: 40px;
  /* Button width */
  height: 40px;
  /* Button height */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  /* Adjust font size for the icon */
  color: white;
  /* White color for the checkmark */
  cursor: pointer;
  /* Pointer cursor for better UX */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  /* Subtle shadow for a raised effect */
}

.close-btn:hover {
  background: darkgreen;
  /* Darker green on hover */
}

.error-message {
  color: red;
  margin-top: 10px;
}

.scroll-container {
  max-height: 80vh;
  overflow-y: auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.info-row {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
  margin-bottom: 10px;
}

.info-row h6 {
  margin-bottom: 5px;
}
</style>
